module.exports = __webpack_public_path__ + "static/media/work.0792fd28.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/work.JPG
// module id = 155
// module chunks = 0